import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Select from 'react-select';
import './AddressingPopup.css';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import {jwtDecode} from "jwt-decode";
import {FaUserPlus} from "react-icons/fa";
import CaseUserStatus from "../../../enums/CaseUserStatus";
import CaseNotificationEnum from "../../../enums/CaseNotiFicationEnum";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {ka} from "date-fns/locale";
import {Tooltip} from "@mui/material";
import {IoClose} from "react-icons/io5";

const AddressingPopup = ({
                             roleName,
                             onManagerAdded,
                             caseManagers,
                             caseDataDays,
                             departmentId,
                             deps,
                             internalUsers,
                             groupId,
                             holidays,
                             cancelDocExists
                         }) => {
    const token = localStorage.getItem('jwtToken');
    const decodedToken = jwtDecode(token);
    const userId = decodedToken.sub;
    const [selectedUserId, setSelectedUserId] = useState('');
    const [selectedUserIdRole, setSelectedUserRole] = useState('');
    const [selectedUserIdDepartment, setSelectedUserDepartment] = useState('');
    const [users, setUsers] = useState([]);
    const [userViewers, setUserViewers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [headOfDepartmentWasPicked, setHeadOfDepartmentWasPicked] = useState(false);
    const [deadlineDays, setDeadlineDays] = useState(parseInt(caseDataDays) > 0 ? caseDataDays : '');
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [alertInfo, setAlertInfo] = useState({show: false, message: '', type: ''});
    const [departments, setDepartments] = useState([]);
    const [selectedUserViewerOptions, setSelectedUserViewerOptions] = useState([]);
    const [selectedViewerDepartment, setSelectedViewerDepartment] = useState(null);
    const [selectedDepartment, setSelectedDepartment] = useState(departmentId);
    const [startDate, setStartDate] = useState(null);

    React.useEffect(() => {
        document.body.style.overflow = showPopup ? 'hidden' : 'auto';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showPopup]);


    const isHoliday = (date) => {
        const formattedDate = formatDate(date);
        return holidays.some(holiday => formatDate(new Date(holiday.date)) === formattedDate);
    };

    const formatDate = (date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    };

    const filterDates = (date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return date > today && !isHoliday(date);
    };


    useEffect(() => {
        if (deadlineDays && !isNaN(deadlineDays)) {
            let computedDate = new Date();
            let daysAdded = 0;

            while (daysAdded < deadlineDays) {
                computedDate.setDate(computedDate.getDate() + 1);
                if (filterDates(computedDate)) {
                    daysAdded++;
                }
            }

            setStartDate(computedDate);
        }
    }, [deadlineDays]);


    const customStyles = {
        menuList: (provided) => ({
            ...provided,
            maxHeight: '600px',
        }),
    };

    useEffect(() => {
        const allDepartmentsOption = [{id: null, name: "ყველა დეპარტამენტი"}];
        setDepartments(allDepartmentsOption.concat(deps));
    }, [deps]);

    const handleChangeCheckbox = (userId) => {
        setSelectedUserViewerOptions(prevOptions =>
            prevOptions.map(option => {
                if (option.value === userId) {
                    return {...option, isChecked: !option.isChecked};
                }
                return option;
            })
        );
    };
    const addBusinessDays = (startDate, numDays) => {
        let date = new Date(startDate);
        while (numDays > 0) {
            date.setDate(date.getDate() + 1);
            if (filterDates(date)) {
                numDays--;
            }
        }
        return date;
    };

    const countBusinessDays = (start, end) => {
        let daysCount = 0;
        let date = new Date(start);
        while (date < end) {
            date.setDate(date.getDate() + 1);
            if (filterDates(date)) {
                daysCount++;
            }
        }
        return daysCount;
    };

    useEffect(() => {
        if (deadlineDays === 0 || deadlineDays === null) {
            setStartDate(null);
        } else if (deadlineDays && !isNaN(deadlineDays)) {
            const newDate = addBusinessDays(new Date(), parseInt(deadlineDays));
            setStartDate(newDate);
        }
    }, [deadlineDays]);

    const handleDateChange = (date) => {
        setStartDate(date);
        const businessDays = countBusinessDays(new Date(), date);
        setDeadlineDays(businessDays.toString());
    };


    const rolesInGeorgian = {
        'HeadOfAgency': "სააგენტოს უფროსი",
        'DeputyHeadOfAgency': "უფროსის მოადგილე",
        'HeadOfDepartment': "სამმართველოს უფროსი",
        'Expert': "სპეციალისტი"
    };


    const fetchUserDetails = async (userId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/User/GetOneUserByID?UserID=${userId}`);
            const data = response.data;
            return data.data;
        } catch (error) {
            console.error(error);
            return null;
        }
    };

    useEffect(() => {
        if (roleName === "HEADOFDEPARTMENT") {
            const getUserDetails = async () => {
                const headOfDepartmentInfo = await fetchUserDetails(userId);
                if (headOfDepartmentInfo) {
                    setSelectedDepartment(headOfDepartmentInfo.departmentId);
                }
            };
            void getUserDetails();
        }
    }, [roleName, userId]);



    useEffect(() => {
        const fetchUsers = async () => {
            try {

                const rolePriority = {
                    'HeadOfAgency': 1,
                    'DeputyHeadOfAgency': 2,
                    'HeadOfDepartment': 3,
                    'Expert': 4
                };

                internalUsers.sort((a, b) => {
                    if (rolePriority[a.roleName] !== rolePriority[b.roleName]) {
                        return rolePriority[a.roleName] - rolePriority[b.roleName];
                    } else {
                        return a.firstName.localeCompare(b.firstName);
                    }
                });

                if (roleName === "HEADOFAGENCY") {
                    setUsers(internalUsers);
                    setUserViewers(internalUsers);
                } else if (roleName === "DEPUTYHEADOFAGENCY") {
                    const deputyUsers = internalUsers.filter(user => user.roleName !== "DeputyHeadOfAgency");
                    setUsers(deputyUsers);
                    setUserViewers(deputyUsers);
                } else {
                    const currentUser = internalUsers.find(user => user.id === userId);
                    let departmentUsers = [];
                    let headOfDepartments = [];

                    if (currentUser) {
                        departmentUsers = internalUsers.filter(user => user.departmentId === currentUser.departmentId && user.id !== userId);
                        headOfDepartments = internalUsers.filter(user => user.roleName === "HeadOfDepartment" && user.id !== userId);
                        const filteredUsers = [...departmentUsers, ...headOfDepartments.filter(hod => !departmentUsers.some(du => du.id === hod.id))];
                        setUsers(filteredUsers);
                        setUserViewers(filteredUsers);
                    }
                }
            } catch (error) {
                console.error(error);
            }
        };
        void fetchUsers();
    }, [userId, roleName, token]);

    const formatUserOptions = (users) => {
        return users
            .filter(user => selectedDepartment === null || user.departmentId === selectedDepartment || user.roleName === "DeputyHeadOfAgency")
            .filter(user => !selectedUserViewerOptions.some(viewer => viewer.value === user.id))
            .map(user => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName]})`,
                role: user.roleName.toUpperCase(),
                departmentId: user.departmentId
            }));
    };

    const formatUserViewerOptions = (users) => {
        return users
            .filter(user => user.roleName !== "DeputyHeadOfAgency")
            .filter(user => user.departmentId !== selectedDepartment)
            .filter(user => selectedViewerDepartment === null || user.departmentId === selectedViewerDepartment)
            .filter(user => user.id !== selectedUserId)

            .map(user => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName]})`,
                isChecked: false,
                role: user.roleName.toUpperCase(),
                departmentId: user.departmentId
            }));
    };
    const formatUserViewerOptionsForHeadOfDepartment = (users) => {
        return users
            .filter(user => user.roleName !== "DeputyHeadOfAgency")
            .filter(user => user.departmentId === selectedDepartment)
            .filter(user => selectedViewerDepartment === null || user.departmentId === selectedViewerDepartment)
            .filter(user => user.id !== selectedUserId)

            .map(user => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName]})`,
                isChecked: false,
                role: user.roleName.toUpperCase(),
                departmentId: user.departmentId
            }));
    };

    const handleUserChange = (selectedOption) => {
        setSelectedUserId(selectedOption ? selectedOption.value : '');
        setSelectedUserRole(selectedOption ? selectedOption.role : '');
        setSelectedUserDepartment(selectedOption ? selectedOption.departmentId : '');
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        const deadline = parseInt(deadlineDays, 10);
        if (!selectedUserId || isNaN(deadline) || deadline <= 0 || deadline > 100) {
            return;
        }
        const uncheckedCount = selectedUserViewerOptions.filter(option => !option.isChecked).length;
        if (uncheckedCount === 1) {
            setShowConfirmationModal(true);
        }
        setShowConfirmationModal(true);
    };

    const handleConfirm = async () => {
        setLoading(true);
        let chatUsers = []
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/AddNewCaseUser`;
        const caseId = new URLSearchParams(window.location.search).get('id');
        const payload = {
            caseId: caseId ? parseInt(caseId, 10) : 0,
            toUserId: selectedUserId,
            dedlineDays: parseInt(deadlineDays, 10),
            status: 0,
            addedBySystem: false,
            caseUserType: CaseUserStatus.CaseUser
        };

        try {
            const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency") || {id: null};
            const headOfDepartment = users.find(user => user.roleName === "HeadOfDepartment" && user.departmentId === selectedUserIdDepartment) || {id: null};

            const isDeputyAddedToFlow = caseManagers.find(manager => manager.toUserId === deputyHeadOfAgency.id);
            if ((selectedUserIdRole === "HEADOFDEPARTMENT" || selectedUserIdRole === "EXPERT") && roleName !== "DEPUTYHEADOFAGENCY" && roleName !== "HEADOFDEPARTMENT") {
                const payload = {
                    caseId: caseId ? parseInt(caseId, 10) : 0,
                    toUserId: deputyHeadOfAgency.id,
                    dedlineDays: parseInt(deadlineDays, 10),
                    status: 0,
                    addedBySystem: true,
                    caseUserType: CaseUserStatus.CaseUser
                };
                if (!isDeputyAddedToFlow && selectedUserId !== "") {
                    await axios.post(apiUrl, payload);
                    chatUsers.push(payload.toUserId)
                }
                const caseNotification = {
                    nextStepUserId: deputyHeadOfAgency.id,
                    caseId: caseId ? parseInt(caseId, 10) : 0,
                    documentId: null,
                    action: CaseNotificationEnum.added.id,
                    caseStatus: 8,
                    viewed: false
                };
                if (!isDeputyAddedToFlow && selectedUserId !== "") {
                    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
                }

            }


            if (selectedUserIdRole === "EXPERT" && roleName !== "HEADOFDEPARTMENT" && selectedUserId !== "") {
                const payload = {
                    caseId: caseId ? parseInt(caseId, 10) : 0,
                    toUserId: headOfDepartment.id,
                    dedlineDays: parseInt(deadlineDays, 10),
                    status: 0,
                    addedBySystem: true,
                    caseUserType: CaseUserStatus.CaseUser
                };


                const caseNotification = {
                    nextStepUserId: headOfDepartment.id,
                    caseId: caseId ? parseInt(caseId, 10) : 0,
                    documentId: null,
                    action: CaseNotificationEnum.added.id,
                    caseStatus: 8,
                    viewed: false
                };

                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);

                await axios.post(apiUrl, payload);
                chatUsers.push(payload.toUserId)
            }


            let addedHeadOfDepartments = [];
            let addedHeadOfDepartmentsNotifications = [];

            selectedUserViewerOptions.sort((a, b) => (b.isChecked === true) - (a.isChecked === true));

            await Promise.all(selectedUserViewerOptions.map((viewer) => {

                if (headOfDepartment) {
                    if (
                        viewer.role === "EXPERT" &&
                        roleName !== "HEADOFDEPARTMENT" &&
                        !addedHeadOfDepartmentsNotifications.includes(headOfDepartment.id)
                    ) {
                        const caseNotification = {
                            nextStepUserId: headOfDepartment.id,
                            caseId: caseId ? parseInt(caseId, 10) : 0,
                            documentId: null,
                            action: CaseNotificationEnum.added.id,
                            caseStatus: 8,
                            viewed: false,
                            role: viewer.isChecked ? 2 : 3
                        };
                        addedHeadOfDepartmentsNotifications.push(headOfDepartment.id);
                        return axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
                    }
                }
            }));

            await Promise.all(selectedUserViewerOptions.map((viewer) => {
                const headOfDepartment = users.find(
                    user => user.roleName === "HeadOfDepartment" && user.departmentId === viewer.departmentId
                );
                const isHeadOfDepartmentAlreadyPicked = headOfDepartment
                    ? selectedUserViewerOptions.find(user => user.value === headOfDepartment.id)
                    : null;

                if (roleName !== "HEADOFDEPARTMENT") {
                    if (viewer.role === "EXPERT" && roleName !== "HEADOFDEPARTMENT" && !addedHeadOfDepartments.includes(headOfDepartment.id) && !isHeadOfDepartmentAlreadyPicked) {
                        const payloadViewer = {
                            caseId: caseId ? parseInt(caseId, 10) : 0,
                            toUserId: headOfDepartment.id,
                            dedlineDays: null,
                            status: 0,
                            addedBySystem: false,
                            caseUserType: CaseUserStatus.CaseViewer,
                            approver: viewer.isChecked
                        };
                        addedHeadOfDepartments.push(headOfDepartment.id);
                        chatUsers.push(payloadViewer.toUserId)
                        return axios.post(apiUrl, payloadViewer);
                    }
                }
            }));

            await Promise.all(selectedUserViewerOptions.map((viewer) => {
                const payloadViewer = {
                    caseId: caseId ? parseInt(caseId, 10) : 0,
                    toUserId: viewer.value,
                    dedlineDays: null,
                    status: 0,
                    addedBySystem: false,
                    caseUserType: CaseUserStatus.CaseViewer,
                    approver: viewer.isChecked
                };

                chatUsers.push(payloadViewer.toUserId)
                return axios.post(apiUrl, payloadViewer);

            }));

            await Promise.all(selectedUserViewerOptions.map((viewer) => {
                const caseNotification = {
                    nextStepUserId: viewer.value,
                    caseId: caseId ? parseInt(caseId, 10) : 0,
                    documentId: null,
                    action: CaseNotificationEnum.added.id,
                    caseStatus: 8,
                    viewed: false,
                    role: viewer.isChecked ? 2 : 3

                };
                return axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
            }));

            await axios.post(apiUrl, payload);
            chatUsers.push(payload.toUserId)

            const caseNotification = {
                nextStepUserId: selectedUserId,
                caseId: caseId ? parseInt(caseId, 10) : 0,
                documentId: null,
                action: CaseNotificationEnum.added.id,
                caseStatus: 8,
                viewed: false
            };

            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);


            setShowPopup(false);
            setSelectedUserId('');
            setAlertInfo({show: true, message: 'მენეჯერი წარმატებით დაემატა!', type: 'success'});
            onManagerAdded();

        } catch (error) {
            setAlertInfo({show: true, message: error.toString(), type: 'error'});
            console.error(error);
        } finally {
            setSelectedViewerDepartment(null)
            setSelectedUserViewerOptions([])
            setLoading(false);
            setShowConfirmationModal(false);
            const chatUsersPayload = {
                chatName: groupId.chatName,
                chatUsersIds: [...groupId.chatUsersIds, ...chatUsers],
                id: groupId.id,
                caseNumber: groupId.caseNumber,
                caseID: groupId.caseID

            };

            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditChatGroup`, chatUsersPayload);
        }
    };

    const userOptions = formatUserOptions(users);
    const userViewerOptions = formatUserViewerOptions(userViewers);
    const userViewerOptionsForHeadOfDepartment = formatUserViewerOptionsForHeadOfDepartment(userViewers);

    const handleChangeUserViewer = (selectedValues) => {
        setSelectedUserViewerOptions(selectedValues);
    };


    useEffect(() => {

        if ((roleName === "HEADOFAGENCY") && userOptions.length > 0 && !headOfDepartmentWasPicked) {
            const deputy = userOptions.find(user => user.role === "DEPUTYHEADOFAGENCY");

            if (deputy) {
                setHeadOfDepartmentWasPicked(true)
                handleUserChange(deputy);
            }
        }

        else if ((roleName === "DEPUTYHEADOFAGENCY") && userOptions.length > 0 && !headOfDepartmentWasPicked) {
            const headOfDepartment = userOptions.find(user => user.role === "HEADOFDEPARTMENT" && user.departmentId === departmentId);

            if (headOfDepartment) {
                setHeadOfDepartmentWasPicked(true)
                handleUserChange(headOfDepartment);
            }
        }
    }, [userOptions, roleName, departmentId]);


    return (
        <div>
            {showPopup && (
                <div className="overlay"></div>
            )}
            <button
                onClick={() => setShowPopup(true)}
                className="document-buttonn"
            >
                <span style={{marginRight: 15}} className="button-label">დამატება</span>
                <div className="button-icon-container">
                    <span style={{fontSize: 20}} className="button-icon"><FaUserPlus/></span>
                </div>
            </button>

            {showPopup && (
                <div className="popup">
                    <IoClose className="upload-single-close-icon" onClick={() => setShowPopup(false)} />
                    <form onSubmit={handleSubmit} className="form-container-user-select">
                        <h4>დეპარტამენტი</h4>
                        <Select
                            style={{cursor: "pointer"}}
                            options={departments.map(department => ({
                                value: department.id,
                                label: department.name
                            }))}
                            value={departments.find(department => department.id === selectedDepartment) ? {
                                value: selectedDepartment,
                                label: departments.find(department => department.id === selectedDepartment)?.name
                            } : null}
                            onChange={selectedOption => setSelectedDepartment(selectedOption ? selectedOption.value : null)}
                            className="search-select-popup"
                            placeholder="აირჩიეთ დეპარტამენტი..."
                            isClearable
                            isSearchable
                            isDisabled={cancelDocExists}
                            noOptionsMessage={() => "არაფერი მოიძებნა"}
                        />
                        <h4>შემსრულებელი</h4>
                        <Select
                            options={userOptions}
                            value={userOptions.find(option => option.value === selectedUserId)}
                            onChange={handleUserChange}
                            className="search-select-popup"
                            placeholder="მოძებნეთ შემსრულებელი..."
                            isClearable
                            isSearchable
                            noOptionsMessage={() => "არაფერი მოიძებნა"}
                        />
                        <h4>დღეების რაოდენობა</h4>
                        <input
                            type="number"
                            value={deadlineDays}
                            onChange={(e) => {
                                let value = e.target.value;
                                if (value === '' || (Number(value) > 0 && Number(value) <= 90 && !value.includes('-'))) {
                                    setDeadlineDays(value);
                                }
                            }}
                            placeholder="დღეების რაოდენობა"
                            className="addressing-popup-deadline"
                            min="1"
                            max="90"
                        />
                        <div style={{width: "100%"}}>
                            <DatePicker
                                selected={startDate}
                                onChange={handleDateChange}
                                filterDate={filterDates}
                                placeholderText="აირჩიეთ თარიღი"
                                dropdownMode="select"
                                dateFormat="dd/MM/yyyy"
                                locale={ka}
                                className="addressing-popup-deadline"
                                showMonthDropdown
                                showYearDropdown
                                adjustDateOnChange
                            />
                        </div>
                        {roleName !== "HEADOFDEPARTMENT" && (
                            <>
                                <h4>დამატებითი შემსრულებლის დეპარტამენტი</h4>
                                <Select
                                    style={{cursor: "pointer"}}
                                    options={departments
                                        .filter(department => department.id !== selectedDepartment) // Filter out the selected department
                                        .map(department => ({
                                            value: department.id,
                                            label: department.name
                                        }))}
                                    value={departments.find(department => department.id === selectedViewerDepartment) ? {
                                        value: selectedViewerDepartment,
                                        label: departments.find(department => department.id === selectedViewerDepartment)?.name
                                    } : null}
                                    onChange={selectedOption => setSelectedViewerDepartment(selectedOption ? selectedOption.value : null)}
                                    className="search-select-popup"
                                    placeholder="აირჩიეთ დამატებითი შემსრულებლის დეპარტამენტი..."
                                    isClearable
                                    isSearchable
                                    noOptionsMessage={() => "არაფერი მოიძებნა"}
                                />
                            </>
                        )}


                        <h4>დამატებითი შემსრულებლი</h4>
                        {roleName !== "HEADOFDEPARTMENT" ? (
                            <Select
                                style={{cursor: "pointer"}}
                                options={userViewerOptions}
                                className="search-select-popup"
                                placeholder="მოძებნეთ დამატებითი შემსრულებლი..."
                                isClearable
                                isSearchable
                                noOptionsMessage={() => "არაფერი მოიძებნა"}
                                isMulti
                                onChange={handleChangeUserViewer}
                                value={selectedUserViewerOptions}
                                menuPlacement="top"
                                styles={customStyles}

                            />
                        ) : (
                            <Select
                                style={{cursor: "pointer"}}
                                options={userViewerOptionsForHeadOfDepartment}
                                className="search-select-popup"
                                placeholder="მოძებნეთ დამატებითი შემსრულებლი..."
                                isClearable
                                isSearchable
                                noOptionsMessage={() => "არაფერი მოიძებნა"}
                                isMulti
                                onChange={handleChangeUserViewer}
                                value={selectedUserViewerOptions}
                                menuPlacement="top"
                                styles={customStyles}

                            />
                        )}


                        <div>
                            {selectedUserViewerOptions.map((option) => (
                                <div className="checkbox-label-container" key={option.value}>
                                    <label>{option.label}</label>
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <div style={{paddingRight: 10}}> ვიზატორი:</div>
                                        <input
                                            style={{cursor: "pointer"}}
                                            type="checkbox"
                                            checked={option.isChecked}
                                            onChange={() => handleChangeCheckbox(option.value)}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                        {loading ? (
                            <div className="loader"></div>
                        ) : (

                            <div>
                                <Tooltip title={
                                    selectedUserId === "" ? "გთოხვთ აირჩიოთ შემსრულებელი" :
                                    deadlineDays < 1 ? "გთხოვთ მიუთთოთ დღეების რაოდენობა" :
                                        ""
                                }>
                                    <div>
                                        <button
                                            type="submit"
                                            style={{fontFamily: "'FiraGO-SemiBold'"}}
                                            className="submit-button"
                                            disabled={selectedUserId === '' || deadlineDays <= 0}
                                        >
                                            შენახვა
                                        </button>
                                    </div>
                                </Tooltip>
                            </div>
                        )}
                    </form>

                </div>
            )}
            <ConfirmationModal
                isOpen={showConfirmationModal}
                onRequestClose={() => setShowConfirmationModal(false)}
                onConfirm={handleConfirm}
            />
            {alertInfo.show && (
                <CustomAlert
                    message={alertInfo.message}
                    type={alertInfo.type}
                    onClose={() => setAlertInfo({show: false, message: '', type: ''})}
                />
            )}
        </div>
    );
};

export default AddressingPopup;
